import { Controller } from "@hotwired/stimulus"

/*
  アコーディオンの制御を伴うテキスト要素を扱います
  job-card-moreのクラスが指定された要素に、
  openクラスを指定することで隠れていた部分をすべて表示します
  @example
    <div class="js-more" data-controller="relasic--job-card-more">
      テキストテキストテキストテキストテキスト
      <button class="js-more-btn" data-action="click->relasic--job-card-more#open">
        <%= image_tag 'relasic/svg/svg-triangle.svg', alt: "", width: 10, height: 10 %>
      </button>
    </div>
 */
export default class extends Controller {
  open() {
    // 親要素に`is-open`クラスを追加し、隠していた部分をすべて表示する
    this.element.classList.add("is-open");
    // ボタンを非表示にする
    const button = this.element.querySelector(".js-more-btn");
    if (button) {
      button.style.display = "none";
    }
  }
}